<div class="item-grid-container">
  <div class="pricelist-selecetion-blk mb-5 mb-sm-0 mx-3">
    <ul class="list-inline">
      <li class="list-inline-item">
        <div class="form-item-label">
          <h4 class="selection-label products-label" translate>
            pages.newRetailer.productChangesMadeIn
          </h4>
        </div>
      </li>
      <li class="list-inline-item">
        <div class="form-item-input search-dropdown">
          <mat-form-field appearance="outline">
            <mat-select
              [(value)]="selectedDays"
              name="pricelist"
              (selectionChange)="changehistory($event)"
            >
              <mat-option
                [value]="dayCount.days"
                *ngFor="let dayCount of historyDays"
              >
                {{ dayCount.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </li>
    </ul>
    <ul class="list-inline search-holder">
      <li class="list-inline-item ">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInput
          class="
            rounded-pill
            px-3
            py-2
            mb-1
            border-0
            bg-light
            w-100
            me-0
            mb-0
            input-search
            ms-3
          "
          (keyup)="quickhistorySearch()"
          [(ngModel)]="searchhistoryValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>
      <li class="list-inline-item float-end">
        <button
        [disabled]="isButtonDisabled"
          mat-stroked-button
          class="bg-theme ms-2"
          (click)="exporthistoryData()"
        >
          <span translate class="translate">pages.newRetailer.download</span>
          <i class="mi mi-save-alt ms-2"></i>
        </button>
      </li>
    </ul>
  </div>
  <ag-grid-angular
    style="width: 100%; height: 65vh"
    class="ag-theme-material mt-3"
    id="historygrid"
    [rowHeight]="40"
    [enableFilter]="true"
    [enableSorting]="true"
    [enableColResize]="true"
    [rowSelection]="rowSelection"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
